import clsx from 'clsx';
import React from 'react';
export const WarningText = (props) => {
    const { children, className } = props;
    return (React.createElement("div", { className: clsx('warning-text', className) },
        React.createElement("div", { className: "warning-text__icon" },
            React.createElement("i", { className: "fas fa-exclamation-triangle" })),
        React.createElement("div", { className: "warning-text__body" }, children)));
};
